"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopedDataMemberTrackingStrategy = void 0;
var ScopedDataMemberTrackingStrategy;
(function (ScopedDataMemberTrackingStrategy) {
    ScopedDataMemberTrackingStrategy["UnsortedSet"] = "UnsortedSet";
    ScopedDataMemberTrackingStrategy["TimeSortedSet"] = "TimeSortedSet";
    // /**
    //  * Member is stored in an UnsortedSet, but one that contains hours from unix epoch.
    //  * Intended for time-based cleanups.
    //  * WARNING: only use for items that are only set once. Otherwise, the bucket can be tracked in multiple sets and might be removed/cleaned
    //  *   when it was actually updated recently.
    //  * 
    //  */
    // HourlyRotatingLog = 'HourlyRotatingLog',
    ScopedDataMemberTrackingStrategy["None"] = "None";
})(ScopedDataMemberTrackingStrategy = exports.ScopedDataMemberTrackingStrategy || (exports.ScopedDataMemberTrackingStrategy = {}));
//# sourceMappingURL=redis-member-tracking.js.map